/** Terms shown on subscription + sale invoices / thermal receipts. */
export const INVOICE_TERMS_TITLE = 'Terms & Condition';

export const INVOICE_TERMS = [
  'Membership is personal Non-Refundable and Non-transferable.',
  'Proper attire is must. Please wear T-shirts, Sports trousers and joggers for exercise.',
  'Smoking, vaping, alcohol, and illegal drugs are prohibited on the premises.',
  'The gym is not liable for lost, stolen, or damaged personal property.',
  'The gym reserves the right to suspend or terminate membership & Guest pass without any reason.',
];

export function getInvoiceTermsSummary() {
  return [
    'This is a computer-generated receipt and does not require a signature.',
    ...INVOICE_TERMS.map((line, index) => `${index + 1}. ${line}`),
  ];
}

export function buildInvoiceTermsHtml(escapeHtml) {
  const items = INVOICE_TERMS.map((line) => `<li>${escapeHtml(line)}</li>`).join('');
  return `
    <div class="invoice-terms">
      <h3 class="invoice-terms-title">${escapeHtml(INVOICE_TERMS_TITLE)}</h3>
      <ul class="invoice-terms-list">${items}</ul>
    </div>`;
}
